import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "overlay", "close"]

  connect() {
    this.isOpen = false
    this.boundOpen = this.open.bind(this)
    this.boundHandleKeydown = this.handleKeydown.bind(this)
    this.openTriggers = document.querySelectorAll("[data-job-transactions-panel-open]")

    this.openTriggers.forEach((trigger) => {
      trigger.addEventListener("click", this.boundOpen)
    })
  }

  disconnect() {
    if (this.isOpen) this.close()

    this.openTriggers.forEach((trigger) => {
      trigger.removeEventListener("click", this.boundOpen)
    })
    document.removeEventListener("keydown", this.boundHandleKeydown)
  }

  open(event) {
    event?.preventDefault()
    if (this.isOpen) return

    this.isOpen = true
    this.panelTarget.classList.remove("translate-x-full")
    document.body.classList.add("overflow-hidden")
    this.overlayTarget.classList.remove("opacity-0", "pointer-events-none", "hidden")
    document.addEventListener("keydown", this.boundHandleKeydown)
  }

  close(event) {
    event?.preventDefault()
    if (!this.isOpen) return

    this.isOpen = false
    this.panelTarget.classList.add("translate-x-full")
    document.body.classList.remove("overflow-hidden")
    this.overlayTarget.classList.add("opacity-0", "pointer-events-none", "hidden")
    document.removeEventListener("keydown", this.boundHandleKeydown)
  }

  handleKeydown(event) {
    if (event.key === "Escape") this.close()
  }
}
